import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="questionnaires"
export default class extends Controller {
  static targets = ["form", "elapsedTime", "learningTime"]
  timer = null;
  connect() {
    this.initializeTimer();
    this.startTimer();
    this.formTarget.addEventListener("submit", this.handleSubmit.bind(this));
  }

  initializeTimer() {
    // サーバーから受け取った時刻をミリ秒単位に変換
    this.learningTimeValue = parseInt(this.learningTimeTarget.value, 10) * 1000;
    this.startTimer();
  }
  startTimer() {
    // 1秒ごとに経過時間を更新するタイマーを設定
    this.timer = setInterval(() => {
      this.learningTimeValue += 1000; // 学修時間を1秒ずつ増やす
    }, 1000);
  }
  stopTimer() {
    clearInterval(this.timer);
  }
  handleSubmit() {
    // タイマーを停止
    this.stopTimer();
    // サーバーに送信するために経過時間をセット
    const elapsedSeconds = Math.floor(this.learningTimeValue / 1000);
    this.elapsedTimeTarget.value = elapsedSeconds;
  }
}
